/** Location */

'use strict'

$(document).ready(function () {
  // Toggle show/hide location map
  $('#ShowMaps').change(function () {
    $(".location__maps").toggleClass("d-none");
    $(".container").toggleClass("full-width");
    $(".location-list__content").toggleClass("full-width");
  });
});